import * as types from '../actionTypes/organizations';

const initialState = {
  orgList: null,
  orgListLoading: false,
  orgListError: null,
  currentOrg: null,
  currentOrgLoading: false,
  currentOrgError: null,
  createOrgLoading: false,
  createOrgError: null,
  orgSubscribers: null,
  orgSubscribersLoading: false,
  orgSubscribersError: null,
};

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LIST_organizationS:
      return {
        ...state,
        orgListLoading: true,
      };
    case types.LIST_organizationS_SUCCESS:
      return {
        ...state,
        orgList: action.payload,
        orgListLoading: false,
      };
    case types.LIST_organizationS_FAILED:
      return {
        ...state,
        orgListLoading: false,
        orgListError: action.payload,
      };
    case types.VIEW_organization:
      return {
        ...state,
        currentOrgLoading: true,
      };
    case types.VIEW_organization_SUCCESS:
      return {
        ...state,
        currentOrg: action.payload,
        currentOrgLoading: false,
      };
    case types.VIEW_organization_FAIL:
      return {
        ...state,
        currentOrgLoading: false,
        currentOrgError: action.payload,
      };
    case types.VIEW_organization_SUBSCRIBER:
      return {
        ...state,
        orgSubscribersLoading: true,
      };
    case types.VIEW_organization_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        orgSubscribers: action.payload,
        orgSubscribersLoading: false,
      };
    case types.VIEW_organization_SUBSCRIBER_FAIL:
      return {
        ...state,
        orgSubscribersLoading: false,
        orgSubscribersError: action.payload,
      };
    case types.CREATE_organization:
      return {
        ...state,
        createOrgLoading: true,
      };
    case types.CREATE_organization_SUCCESS:
      return {
        ...state,
        createOrgLoading: false,
      };

    case types.CREATE_organization_FAIL:
      return {
        createOrgError: action.payload,
      };
    default:
      return state;
  }
};

export default organizationReducer;
